



























































import { utils } from '@easygenerator/fragment-sdk';
import { Component, Vue } from 'vue-property-decorator';
import PasswordField from './common/PasswordField.vue';
import CommonForm from './common/CommonForm.vue';
import { FORBIDDEN_EXCEPTION } from '../utils/constants';

@Component({
  components: {
    PasswordField,
    CommonForm
  }
})
export default class ConfirmAccount extends Vue {
  showPassword = false;

  showErrorMessage = false;

  showPasswordErrorMessage = false;

  password = '';

  confirmationEmailSent = false;

  emailConfirmed = false;

  emailToConfirm: string | null = '';

  state: string | null = '';

  shouldShowFormControls = true;

  showResetPassword = false;

  errorMessage = 'Your confirmation request has expired. Please try again.';

  updatePassword(value: string) {
    this.password = value;
  }

  beforeMount() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('email')) {
      this.emailToConfirm = urlParams.get('email');
    }

    if (urlParams.has('state')) {
      this.state = urlParams.get('state');
    }

    if (urlParams.has('success')) {
      this.emailConfirmed = urlParams.get('success') === 'true';
    }

    if (urlParams.has('error')) {
      this.errorMessage = urlParams.get('error') || this.errorMessage;
      this.showErrorMessage = true;
    }

    this.confirmationEmailSent = !this.emailToConfirm || !this.state;
    this.shouldShowFormControls = !this.showErrorMessage && !this.confirmationEmailSent && !this.emailConfirmed;
  }

  hidePasswordErrorMessage(): void {
    this.showPasswordErrorMessage = false;
  }

  async submitForm(): Promise<void> {
    try {
      const url = `/api/v1/confirm-account/credentials?state=${this.state}`;

      if (!this.password) {
        this.showPasswordErrorMessage = true;
        return;
      }

      const data = {
        email: this.emailToConfirm,
        password: this.password
      };

      const { callbackUrl = '?success=true' } = await utils.HttpWrapper.post(url, {
        body: data,
        headers: { accept: 'application/json' },
        unauthorizedHandler: () => {
          throw new Error('Unauthorized');
        }
      });

      window.open(callbackUrl, '_self');
    } catch (err) {
      if (err.status === FORBIDDEN_EXCEPTION) {
        this.showErrorMessage = true;
        this.shouldShowFormControls = false;
      } else {
        this.showPasswordErrorMessage = true;
        this.showResetPassword = false;
      }
    }
  }

  async sendConfirmationToEmail(): Promise<void> {
    try {
      const url = `/api/v1/confirm-account/request-email-confirmation?state=${this.state}`;

      await utils.HttpWrapper.post(url);
      this.confirmationEmailSent = true;
      this.$router.replace({ query: { email: this.emailToConfirm } });
      this.shouldShowFormControls = false;
    } catch (err) {
      this.showErrorMessage = true;
      this.shouldShowFormControls = false;
    }
  }

  async forgotPassword(): Promise<void> {
    try {
      const url = '/api/credentials/forgot-password';

      const data = {
        email: this.emailToConfirm,
        returnUrl: '/'
      };

      await utils.HttpWrapper.post(url, { body: data, headers: { accept: 'application/json' } });
      this.showResetPassword = true;
    } catch (err) {
      this.showErrorMessage = true;
      this.shouldShowFormControls = false;
      this.errorMessage = 'Something went wrong';
    }
  }
}
